<!--v-if="sport === 'Football'"-->
<template>
    <div>
        <div v-if="sport === 'Football'">
            <Soccer :connection="connection" :eventId="eventId"></Soccer>
        </div>
        <div v-if="sport === 'Tennis'">
            <Tennis :connection="connection" :eventId="eventId"></Tennis>
        </div>
    </div>
</template>

<script>
    import Soccer from './scoreboard/Soccer.vue';
    import Tennis from './scoreboard/Tennis.vue';
    import { HubConnection } from "@aspnet/signalr";
    export default {
        name: 'Scoreboard',
        components: {
            Soccer,
            Tennis
        },
        props: {
            sport: String,
            eventId: String,
            connection: HubConnection,
        },
        mounted() {

        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
